<template>
  <div class="control-wrapper">
    <button @click="toggleMenu" class="toggle-button">
      {{ isMenuVisible ? "隱藏" : "顯示" }}
    </button>

    <section
      class="control-container"
      :class="{ 'menu-visible': isMenuVisible }"
    >
      <h3 class="control-header">工資單管理</h3>

      <section class="item-container">
        <section
          class="control-item"
          v-for="(control, key) in controls"
          :key="key"
        >
          <section class="control">
            <span class="item-label">
              {{ control.label }}
            </span>

            <div class="flex-1" v-if="control.inputType === 'expense_id'">
              <input
                type="text"
                v-model="filter_expense_id"
                class="form-control"
                placeholder="輸入薪金支出記錄ID"
                @input="$emit('update:expense_id', filter_expense_id)"
              />
            </div>
            <!-- <div
              class="flex-1"
              v-else-if="
                control.inputType === 'salary_record_id'
              "
            >
              <div>
                <div v-if="salaryRecordOptions.length === 0" class="text-danger mb-1">
                  沒有可用的薪資記錄選項
                </div>
                <v-select
                  id="filter_salary_record_id"
                  v-model="filter_salary_record_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="salaryRecordOptions"
                  :clearable="false"
                  label="display_text"
                  :reduce="(option) => option.id"
                  placeholder="選擇記錄"
                  :filter="salaryRecordSearch"
                  @input="$emit('update:salary_record_id', filter_salary_record_id)"
                >
                  <template #option="{ display_text }">
                    <div class="salary-record-option">{{ display_text }}</div>
                  </template>
                  <template #selected-option="{ display_text }">
                    <div class="salary-record-selected">{{ display_text }}</div>
                  </template>
                </v-select>
              </div>
            </div> -->
            <!-- <div
              class="flex-1"
              v-else-if="
                control.inputType === 'project_id' &&
                projectOptions &&
                projectOptions.length > 0
              "
            >
              <v-select
                id="filter_project_id"
                v-model="filter_project_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="userProjectOptions"
                label="project_name"
                :reduce="(option) => option.id"
                :filter="projectSearch"
                placeholder="選擇項目"
                @input="$emit('update:project_id', filter_project_id)"
              >
                <template #option="{ project_name }">
                  {{ project_name }}
                </template>>
                <template #selected-option="{ project_name }">
                  {{ project_name }}
                </template>
              </v-select>
            </div> -->

            <div class="flex-1" v-else>
              <input
                :class="
                  control.inputType === 'checkbox'
                    ? 'input-checkbox'
                    : 'input-box'
                "
                :type="control.inputType"
                :value="controlValue[control.vModel]"
                :checked="controlValue[control.vModel]"
                @input="setInput($event, control.vModel, control.inputType)"
                @change="setInput($event, control.vModel, control.inputType)"
              />
            </div>
          </section>

          <section class="options-container">
            <section class="options-item">
              <span class="options-title"> Type: </span>

              <span class="options-value">
                {{ control.type }}
              </span>
            </section>

            <section class="options-item">
              <span class="options-title"> Options: </span>

              <span class="options-value">
                {{ control.options }}
              </span>
            </section>
          </section>

          <section v-if="control.label === 'manual-pagination:'">
            <b>Note:</b> <br />
            When enabling this prop, the prop <br />
            <b> paginate-elements-by-height </b> will not be used. Instead the
            pagination process will rely on the elements with a class
            "html2pdf__page-break" to know where to page break.
          </section>
        </section>
        <!--
            <div>
                <b>Note:</b> <br> There is a prop called <b>html-to-pdf-options</b>, if you set a value to
                this prop, the props below will be overridden: <br><br>
                <b>filename</b><br>
                <b>pdf-quality</b><br>
                <b>pdf-format</b><br>
                <b>pdf-orientation</b>.<br><br>
                Any value inputed to those props above will have no effect.
            </div>
            -->
      </section>

      <b-button
        :disabled="isGenerating"
        class="generate-btn"
        style="margin-bottom: 10px"
        :to="{ name: 'worker-salary-list' }"
        v-if="ability.can('read', 'user_salaries')"
      >
        工資單列表
      </b-button>
      <!-- <b-button
      :disabled="isGenerating"
      class="generate-btn"
      style="margin-bottom: 10px"
      :to="{ name: 'salary-edit', params: { id: salaryData.id } }"
      v-if="ability.can('admin', 'workers') || (ability.can('update', 'salarys') && new Date() - new Date(salaryData.timeout_edit_date) > 0)"
    >
      修改工資單
    </b-button> -->
      <button
        :disabled="isGenerating"
        class="generate-btn"
        @click="$emit('generateReport')"
      >
        {{ isGenerating ? "Loading..." : "生成PDF" }}
      </button>

      <section class="progress-container">
        <div class="progress-bar">
          <div class="progress" :style="`width: ${progress}%;`" />
        </div>

        <section class="generating-label" v-if="progress !== 0">
          <span class="label-title">
            {{ progress === 100 ? "PDF Generated" : "生成PDF" }}
          </span>

          <span class="label-progress">
            {{ `${progress} %` }}
          </span>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { BButton } from "bootstrap-vue";
import ability from "@/libs/acl/ability";
import { sanitizeFilename } from "@core/utils/filter";

export default {
  components: {
    BButton,
    flatPickr,
    vSelect,
  },
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    salaryData: {
      type: Object,
      required: true,
    },
    remarkOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    userOptions: {
      type: Array,
      required: true,
    },
    salary_record_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      ability,
      filter_project_id: null,
      filter_salary_record_id: null,
      controls: [
        {
          label: "檔案名稱:",
          type: "String",
          options: "Any String",
          inputType: "text",
          vModel: "filename",
        },
        // {
        //   label: "選擇記錄:",
        //   type: "salary_record_id",
        //   options: "Select Salary Record",
        //   inputType: "salary_record_id",
        //   vModel: "salary_record_id",
        // },
        // {
        //   label: "備註:",
        //   type: "Remark",
        //   options: "Any Remark",
        //   inputType: "text",
        //   vModel: "remark",
        // },
      ],
      isMenuVisible: true,
    };
  },
  mounted() {
      // 設置簽名日期
      this.controlValue.sign_date = new Date().toISOString().split('T')[0];

      // 設置選中的薪資記錄 ID
      this.filter_salary_record_id = Number(this.salary_record_id);
      // 初始化檔案名稱
      const rawFilename = this.salaryData.name_cn || '工資單';
      this.controlValue.filename = sanitizeFilename(rawFilename) + ' ' + this.controlValue.sign_date + '-工資單.pdf';

      // 調試輸出
      console.log('ControlsContainer mounted, salary_record_id:', this.salary_record_id);
      console.log('ControlsContainer mounted, salaryRecordOptions:', this.salaryRecordOptions);

      
  },

  computed: {
    ...mapFields(["controlValue"]),

    isGenerating() {
      return this.progress !== 0 && this.progress !== 100;
    },

    salaryRecordOptions() {
      return this.$store.state.app.salaryRecordOptions || [];
    },
    userProjectOptions() {
      if (this.filter_user_id) {
        const options = this.projectOptions.filter((project) =>
          project.users && project.users.includes(this.filter_user_id)
        );
        return options.length > 0 ? options : this.projectOptions;
      }
      return this.projectOptions;
    }
  },
  watch: {
    filter_salary_record_id(newVal) {
      this.$emit('update:salary_record_id', newVal);
    }
  },

  methods: {
   

    // 薪資記錄搜索
    salaryRecordSearch(options, search) {
      return options.filter((item) => {
        return item.display_text.toLowerCase().includes(search.toLowerCase());
      });
    },
    setInput(e, key, inputType) {
      let value = e.target.value;

      if (inputType === "checkbox") {
        value = e.target.checked;
      }

      if (inputType === "number") {
        value = e.target.value ? parseFloat(e.target.value) : 0;
      }

      this.$set(this.controlValue, key, value);
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

/* 修復下拉選單選項被截斷的問題 */
.vs__dropdown-menu {
  width: auto !important;
  min-width: 100%;
  white-space: nowrap;
  z-index: 1000;
  max-width: 500px;
}

.vs__dropdown-option {
  padding: 8px 12px;
  white-space: normal;
  word-break: break-word;
}

.vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.salary-record-option {
  white-space: normal;
  word-break: break-word;
  padding: 4px 0;
}

.salary-record-selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.v-select {
  position: relative;
}

.vs__dropdown-toggle {
  padding: 6px 0;
}
</style>